import { Component, Input, Output, EventEmitter, ViewChild, ElementRef, AfterViewInit, OnDestroy } from '@angular/core';
import { UserMessageData } from '../../domain/models/user-message.model';

@Component({
  selector: 'ifc-user-message-page',
  templateUrl: './user-message-page.component.html',
  styleUrls: ['./user-message-page.component.scss'],
  standalone: false
})
export class UserMessagePageComponent implements AfterViewInit, OnDestroy {
  @Input()
  message: UserMessageData;

  @Output()
  acknowledged = new EventEmitter<void>();

  @ViewChild('footerElement', { read: ElementRef })
  footerElement: ElementRef<HTMLElement>;

  isAcknowledged: boolean = false;
  isFooterDisplayed: boolean = false;
  canConfirm: boolean = false;
  private observer: IntersectionObserver = null;

  ngAfterViewInit(): void {
    this.setupObserver();
  }

  updateCanConfirm(): void {
    this.canConfirm = this.isFooterDisplayed && (!this.message?.dismissable || this.isAcknowledged);
  }

  onOkClick(): void {
    if (this.canConfirm) {
      this.acknowledged.emit();
    }
  }

  private setupObserver(): void {
    if (!this.footerElement?.nativeElement) {
      return;
    }
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.isFooterDisplayed = true;
            this.updateCanConfirm();
          }
        });
      },
      { threshold: 0.5 }
    );
    this.observer.observe(this.footerElement.nativeElement);
  }

  ngOnDestroy(): void {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }
}
